import styled from 'styled-components';
import BaseChart from '@components/common/Charts/BaseChart';

export const Header = styled.div`
  line-height: 45px;
  font-size: 20px;
  font-weight: 600;
  padding-left: 20px;
  margin-top: 27px;
`;

const Label = styled.label`
  line-height: 45px;
  font-size: 16px;
  font-weight: 300;
`;

export const EventLabel = styled(Label)`
  position: relative;
  top: 2px;
`;

export const StateLabel = styled(Label)`
  position: relative;
  top: -12px;
`;

export const Wrapper = styled.div`
  .event-table {
    .ts {
      padding-right: 24px;
      text-align: left;
      vertical-align: top;
    }
    .value {
      max-width: 400px;
      vertical-align: top;
      white-space: normal;
      padding-right: 8px;
    }
  }
  .echarts-tooltip {
    padding: 5px;
    font-family: "Roboto", sans-serif !important;
    .time {
      font-weight: 800;
      margin-bottom: 4px;
    }
    .details {
      display: flex;
      ul {
        list-style: none;
        margin: 0;
        padding: 0;
        li {
          margin: 0;
          padding: 0;
          min-width: 1px;
          height: 18px;
          line-height: 18px;
        }
        &.item_names {
          padding-right: 10px;
        }
      }
    }
    .item {
      line-height: 18px;
    }
    .label {
      display: inline-block;
      text-align: left;
      padding-right: 10px;
    }
  }
`;

export const StyledEventBaseChart = styled(BaseChart)`
  width: 100%;
  height: 68px;
`;

export const StyledStateBaseChart = styled(BaseChart)`
  width: 100%;
  height: 80px;
`;
